import type { GAItem } from 'tracking/src/gtm/types/gtm';
import type { RelewiseProduct } from '~/components/features';

type Options = {
  listId?: string;
  listName?: string;
  listType?: string;
  index?: number;
};

/**
 * Maps a RelewiseProduct to a Google Analytics item.
 */
export function relewiseProductToGAItem(product: RelewiseProduct, options: Options = {}): GAItem {
  // Extract category hierarchy from categoryPaths
  const categories: string[] = [];
  if (product.categoryPaths && product.categoryPaths.length > 0) {
    const firstPath = product.categoryPaths[0];
    if (firstPath?.pathFromRoot) {
      categories.push(...firstPath.pathFromRoot
        .map(cat => cat.displayName?.toLowerCase())
        .filter((name): name is string => Boolean(name))
      );
    }
  }

  // Extract brand name
  const brandName = typeof product.brand === 'string'
    ? product.brand
    : product.brand?.displayName;

  const gaItem: GAItem = {
    item_id: product.productId,
    item_name: product.displayName || '',
  };

  // Only add optional fields if they have actual values
  if (product.salesPrice !== undefined && product.salesPrice !== null) {
    gaItem.price = product.salesPrice;
  }

  if (categories[0]) {
    gaItem.item_category = categories[0].toLowerCase();
  }
  if (categories[1]) {
    gaItem.item_category2 = categories[1].toLowerCase();
  }
  if (categories[2]) {
    gaItem.item_category3 = categories[2].toLowerCase();
  }
  if (brandName) {
    gaItem.item_brand = brandName.toLowerCase();
  }
  if (product.variant?.variantId && product.variant.variantId !== product.productId) {
    gaItem.item_variant = product.variant?.variantId;
  }
  if (options?.listName) {
    gaItem.item_list_name = options.listName.toLowerCase();
  }
  if (options?.listId) {
    gaItem.item_list_id = options.listId;
  }
  if (options?.listType) {
    gaItem.item_list_type = options.listType
  }
  if (options?.index !== undefined) {
    gaItem.index = options.index;
  }

  return gaItem;
}